import React, { useState } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import './btn.css'; 

const BarreRecherche = ({onChange, value, type, allowClear, onClick }) => {
  const [focused, setFocused] = useState(false);

  return (
    <div className={`search-bar-container ${focused ? 'focused' : ''}`}>
      <Input  onChange={onChange} value={value} type={type}
        placeholder="Rechercher..." allowClear={allowClear}
        // onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)} 
        bordered={false}
        className="search-input"
        prefix={<SearchOutlined style={{ fontSize: 20, marginRight: 5,  color: "#43CE0C "}}  onClick={() => setFocused(true)} />}
      />
    </div>
  );
};

export default BarreRecherche;
